var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#help-fill_svg__clip0_245_2319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm-.5 19a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0111.5 19zm4.311-8.873c-.309.495-.896 1.051-1.762 1.669-1.401 1.036-1.363 1.266-1.363 2.204h-2.457c0-.733-.016-1.296.38-1.981.253-.439.717-.906 1.391-1.4.809-.578 1.595-1.135 1.595-2.105 0-.909-.778-1.233-1.687-1.233-.927 0-1.984.303-3.171.909L7.726 6.16c2.157-1.209 5.561-1.756 7.422-.241 1.366 1.113 1.374 3.07.663 4.208z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "help-fill_svg__clip0_245_2319"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgHelpFill;